import { render, staticRenderFns } from "./Osb.vue?vue&type=template&id=2770a786&lang=html&"
import script from "./Osb.vue?vue&type=script&lang=js&"
export * from "./Osb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports